// The app is English-only, so formatting is fixed to en-US conventions.

export function formatHours(hours: number): string {
  return `${hours.toFixed(1)} hours`;
}

export function formatCharacters(characters: number): string {
  return Math.round(characters).toLocaleString("en-US");
}

export function formatEurAmount(amount: number): string {
  return `${amount.toFixed(2)} €`;
}
